module.exports = __webpack_public_path__ + "img/pc.ad0f45c3.png";